import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import Button from 'Component/Button';
import {
 SIZE_NONE, TEXT_SIZE_SMALL, TYPE_TEXT, WIDTH_HUG
} from 'Component/Button/Button.config';
import { SIZE_GUIDE_POPUP_ID } from 'Component/SizeGuidePopup/SizeGuidePopup.config';
import { showPopup } from 'Store/Popup/Popup.action';

/** @namespace Bodypwa/Component/SizeGuideAction/Component/SizeGuideActionComponent */
export const SizeGuideActionComponent = ({ label = 'Size info', className = ''  }) => {
    const dispatch = useDispatch();
    const onSizeGuideClick = () => dispatch(showPopup(SIZE_GUIDE_POPUP_ID, {
            action: SIZE_GUIDE_POPUP_ID,
            title: __('Size Guide')
        }));

    const renderSizeGuideAction = () => (
        <Button
            className={ className }
            textSize={ TEXT_SIZE_SMALL }
          // eslint-disable-next-line react/jsx-no-bind
            onClick={ onSizeGuideClick }
            type={ TYPE_TEXT }
            size={ SIZE_NONE }
            text={ __(label) }
            width={ WIDTH_HUG }
        />
    );

    return (
        <div>
            { renderSizeGuideAction() }
        </div>
    );
};

SizeGuideActionComponent.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string
};
SizeGuideActionComponent.defaultProps = {
    className: '',
    label: __('Size Guide')
};

export default SizeGuideActionComponent;
